import React, { useState, useRef, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import SearchInput from '@wix/da-ds/pkg/formControls/dsPresets/SearchInput';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { Url } from '@wix/da-url';
import s from './SearchBar.scss';
var USERNAME_REGEX = /^[A-Za-z0-9][A-Za-z0-9-]{1,18}[A-Za-z0-9]$/;
var SearchBar = function (_a) {
    var onClick = _a.onClick, isActive = _a.isActive, isNewVersion = _a.isNewVersion, isLegacyHeader = _a.isLegacyHeader, isSearchModalShown = _a.isSearchModalShown, _b = _a.searchQuery, searchQuery = _b === void 0 ? '' : _b, className = _a.className, openSearchModal = _a.openSearchModal;
    var t = useTranslation().t;
    var _c = useState(searchQuery), query = _c[0], setQuery = _c[1];
    var searchInputRef = useRef(null);
    var logBiEvent = useBiLogger();
    var handleSearchButtonClick = function () {
        var isSearchPage = location.pathname.startsWith('/search');
        if (!isSearchPage) {
            if (!isSearchModalShown) {
                openSearchModal();
            }
        }
        else {
            onClick && onClick();
        }
    };
    var handleSubmit = useCallback(function (e) {
        var _a, _b;
        e.preventDefault();
        var searchTerm = (_b = (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim();
        if (!searchTerm) {
            return; // dont allow empty search
        }
        var searchUrl = Url.searchLink(searchTerm);
        var username = searchTerm.slice(1);
        var isCorrectUsername = searchTerm.startsWith('@') && USERNAME_REGEX.test(username);
        logBiEvent({
            evid: BiEventType.SEARCH_CLICK,
            search_terms: searchTerm,
            sectionname: 'popup',
        });
        // Only search usernames if we are not on subdomain!
        if (isCorrectUsername && !isLegacyHeader) {
            var userLinkUrl_1 = Url.userLink(username);
            // to test this locally do `.replace('.com', '.lan')`
            var http = new XMLHttpRequest();
            http.open('HEAD', userLinkUrl_1);
            http.onreadystatechange = function () {
                if (this.readyState === this.DONE) {
                    var doesUserExists = this.status === 200;
                    var redirectUrl = doesUserExists ? userLinkUrl_1 : searchUrl;
                    window.location.assign(redirectUrl);
                }
            };
            http.send();
        }
        else {
            window.location.assign(searchUrl);
        }
    }, [isLegacyHeader, logBiEvent]);
    var handleInputKeyDown = useCallback(function (event) {
        if (event.key === 'Enter' || event.key === 'Return') {
            event.preventDefault();
            event.stopPropagation();
            handleSubmit(event);
        }
    }, [handleSubmit]);
    return (React.createElement("div", { className: classnames(s['searchbar-container'], isNewVersion && s['new-version'], className) }, isNewVersion ? (React.createElement("form", { className: s['search-form'], action: Url.searchLink(), onSubmit: handleSubmit },
        React.createElement(SearchInput, { ref: searchInputRef, id: "search-input", label: t('siteHeader.searchBar.placeholder'), placeholder: t('siteHeader.searchBar.placeholder'), value: query, onChange: function (e) { return setQuery(e.target.value); }, onKeyDown: handleInputKeyDown, onClearClick: function () { return setQuery(''); }, noBottomSpacing: true, isLabelHidden: true }))) : (React.createElement(PlainButtonOrLink, { biData: {
            evid: BiEventType.TOP_NAV_CLICK,
            link_name: 'search',
        }, className: classnames('ignore-react-onclickoutside', s['icon-button-searchbar']), onClick: handleSearchButtonClick, "aria-label": t('siteHeader.search.a11y.openSearchDialog') },
        React.createElement(SearchIcon, { className: classnames(s['search-icon'], isActive && s['active']), size: IconSize.MEDIUM, disableDefaultColors: true }),
        React.createElement("span", { className: classnames(s['search-label'], isActive && s['active']) }, t('siteHeader.searchBar'))))));
};
SearchBar.displayName = 'SearchBar';
export default SearchBar;
//# sourceMappingURL=SearchBar.js.map